var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSProgressIndicator } from "@here/hds-react-components/ProgressIndicator";
import { CONFIRM_DAILOG_TEXT } from "../constant";
export var ConfirmBody = function () { return (_jsxs("div", __assign({ style: {
        position: "relative",
        textAlign: "center",
        verticalAlign: "middle",
    } }, { children: [_jsx(HDSProgressIndicator, { color: "accent", variant: "indeterminate", indicatorType: "linear" }), _jsx("p", __assign({ style: { paddingTop: "30px" } }, { children: CONFIRM_DAILOG_TEXT }))] }))); };
